/*
 * @Author: ZJJ
 * @Date: 2025-11-05 19:13:16
 * @LastEditTime: 2025-11-27 09:44:07
 * @FilePath: /boluo_website/src/router/index.js
 * @Description:
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 全局兼容：统一处理重复导航错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === "NavigationDuplicated") return err;
    return Promise.reject(err);
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name === "NavigationDuplicated") return err;
    return Promise.reject(err);
  });
};

const routes = [
  // {
  //   path: "/",
  //   name: "pcHome",
  //   component: () =>
  //     import(/* webpackChunkName: 'pcHome' */ "@/views/pc/index.vue"),
  //   meta: {
  //     title: "首页"
  //   }
  // },
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: 'home' */ "@/views/pc/home.vue"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/column",
    name: "column",
    component: () =>
      import(/* webpackChunkName: 'column' */ "@/views/pc/column.vue"),
    meta: {
      title: "专栏"
    }
  },
  {
    path: "/specialist",
    name: "specialist",
    component: () =>
      import(/* webpackChunkName: 'specialist' */ "@/views/pc/specialist.vue"),
    meta: {
      title: "作者中心"
    }
  },
  {
    path: "/person",
    name: "person",
    component: () =>
      import(/* webpackChunkName: 'person' */ "@/views/pc/person.vue"),
    meta: {
      title: "个人中心"
    }
  },
  {
    path: "/privacyAgreement",
    name: "privacyAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'privacyAgreement' */ "@/views/protocol/privacy-agreement.vue"
      ),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'userAgreement' */ "@/views/protocol/user-agreement.vue"
      ),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: "/privacy-policy",
    name: "HealthPrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: 'HealthPrivacyPolicy' */ "../views/protocol/health-privacy-policy.vue"
      ),
    meta: {
      title: "波萝健康隐私政策"
    }
  },
  {
    path: "/health-user-agreement",
    name: "HealthUserAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'HealthUserAgreement' */ "../views/protocol/health-user-agreement.vue"
      ),
    meta: {
      title: "波萝健康用户服务协议"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [
    ...routes,
    {
      path: "*",
      redirect: "/"
    }
  ],
  // 添加滚动行为配置（针对网页前进/后退处理）
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进后退），则使用保存的位置
    if (savedPosition) {
      // 但对于您的需求，我们总是返回顶部
      return { x: 0, y: 0 };
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 };
    }
  }
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 判断目标路由是否为个人中心
  if (to.path === "/person") {
    // 检查是否有token
    const token = localStorage.getItem("token");
    if (token) {
      // 有token，允许访问
      next();
    } else {
      // 无token，重定向到根路径
      next("/");
    }
  } else {
    // 其他路由正常访问
    next();
  }
});

export default router;
